export const headerLightTheme = {
  '--inftHeader-bgc-1': '#fff',
  '--selectChain-bgc-1': '#f8f8f8',
  '--selectChain-font-c-1': '#333',
  '--selectChain-font-c-2': '#999',
  '--mobileSearch-bgc-1': '#fff',
  '--mobileSearch-font-c-1': '#333',
  '--mobileSearch-font-c-2': '#999',
  '--menu-bgc-1': '#fff',
  '--menu-bgc-2': '#f8f8f8',
  '--menu-font-c-1': '#333',
  '--menu-font-c-2': '#999',
  '--menu-shadow-c-1': '#171d36',
  '--user-bgc-1': '#fff',
  '--user-bgc-2': '#f8f8f8',
  '--user-font-c-1': '#65d5ff',
  '--user-font-c-2': '#333',
  '--user-font-c-3': '#999',
  '--user-font-c-4': '#999',
  '--user-border-c-1': '#098ae5',
  '--user-border-c-2': '#eee',
}
export const headerDarkTheme = {
  '--inftHeader-bgc-1': '#141417',
  '--selectChain-bgc-1': '#23262f',
  '--selectChain-font-c-1': '#fff',
  '--selectChain-font-c-2': '#9fa7b3',
  '--mobileSearch-bgc-1': 'red',
  '--mobileSearch-font-c-1': '#fff',
  '--mobileSearch-font-c-2': '#9fa7b3',
  '--menu-bgc-1': '#23262f',
  '--menu-bgc-2': '#2b2e38',
  '--menu-font-c-1': '#fff',
  '--menu-font-c-2': '#9fa7b3',
  '--menu-shadow-c-1': '#171d36',
  '--user-bgc-1': '#23262f',
  '--user-bgc-2': '#2b2e38',
  '--user-font-c-1': '#65d5ff',
  '--user-font-c-2': '#fff',
  '--user-font-c-3': '#9fa7b3',
  '--user-font-c-4': '#fff',
  '--user-border-c-1': '#098ae5',
  '--user-border-c-2': '#524b50',
}
